export default __webpack_public_path__ + "static/media/emptylist.7c21e79e.svg";